
import WidgetDefaultNuxt from '../default/nuxt.vue';

export default {
  name: 'WidgetLinkButtonNuxt',
  extends: WidgetDefaultNuxt,
  data: function () {
    let href = this.values.href;
    let hrefGroup = this.values.hrefGroup;
    let localePath = [];
    let group = {};
    let isUsedHrefGroup = false;
    for (let key in hrefGroup) {
      let v = '';
      let k = 'hrefGroup_' + key;
      if (hrefGroup[key]?.i18n) {
        localePath.push({ key: k, value: hrefGroup[key] });
        v = this.getLocaleValue(hrefGroup[key]);
      } else {
        v = hrefGroup[key];
      }
      group[k] = v;
      if (v !== '') {
        isUsedHrefGroup = true;
      }
    }
    let link = this.getLocaleValue(href);
    localePath.push({ key: 'link', value: href });
    if (!isUsedHrefGroup && href?.i18n && typeof link === 'object') {
      isUsedHrefGroup = true;
      for (let key in link) {
        let i18nKey = Object.values(href?.i18n);
        let k = 'hrefGroup_' + key;
        i18nKey.push(...[key]);
        group[k] = link[key];
        localePath.push({
          key: k,
          value: {
            i18n: i18nKey,
          },
        });
      }
    }
    let title = this.getLocaleValue(this.values.linkTitle);
    localePath.push({
      key: 'title',
      value: this.values.linkTitle,
    });
    return {
      widgetClassName: 'widget-link-button',
      link,
      title,
      group,
      ...group,
      isUsedHrefGroup,
      localePath: localePath,
      wxAppPath: '',
      wxExtinfoStr: '',
      wxReady: false,
    };
  },
  computed: {
    device() {
      return this.file.device;
    },
    request() {
      return this.file.request;
    },
    hrefGroupByDevice() {
      let list = {};
      for (let key in this.group) {
        list[key.slice(10)] = this[key];
      }
      return {
        isUsed: this.isUsedHrefGroup,
        list: list,
      };
    },
    href: function () {
      const { link } = this;
      var href = '';
      if (typeof navigator === 'undefined' || this.device === '') {
        // 1、服务端渲染时无法获取设备UA，使用默认地址在源码中
        if (typeof link === 'object') {
          href = this.regularGet(link.other || '');
        } else {
          href = this.regularGet(link);
        }
        return href;
      }
      if (this.hrefGroupByDevice.isUsed) {
        href = this.getHrefByObject(this.hrefGroupByDevice.list);
      }
      if (href === '') {
        // 链接组没有匹配到
        if (typeof link === 'object') {
          href = this.getHrefByObject(link);
          if (href === '') {
            // 如果这时候依然为空，可能是因为没有配置 link.other ，使用 link.android 来补救一下
            href = link.other || link.android;
          }
        } else {
          href = link;
        }
      }
      if (typeof href === 'string' && href.indexOf('taptap://') === 0) {
        return href;
      }

      // 二、开始常规字符串识别
      // GET[p1[, p2[, p3]]]  p1:参数key p2:未找到匹配时的默认值 p3:前缀连接符
      href = this.regularGet(href);

      if (
        href &&
        href.indexOf('#') !== 0 &&
        href.indexOf('0') !== 0 &&
        href.indexOf('@') !== 0 &&
        window &&
        window.moo.getUrl
      ) {
        href = window.moo.TAPTAP.getHrefInTapTap(href);
      }
      return href;
    },
    isAnchorLink() {
      return this.href[0] === '#';
    },
    isInnerPage() {
      return this.href[0] === '@';
    },
    isJavascript() {
      if (
        typeof window !== 'undefined' &&
        this.values.openInTapClient &&
        !window.moo.CONSTANT.IS_IN_TAPTAP
      ) {
        return true;
      }
      if (this.isInnerPage) {
        return true;
      }
      if (this.isAnchorLink && this.values.linkConfig?.scroll) {
        return true;
      }
      return !this.href || this.href === '';
    },
  },
  mounted() {
    // 在安卓机的微信中使用跳转功能，仅限 www.taptap.cn 的页面
    if (
      typeof window !== 'undefined' &&
      window.moo.getUri &&
      this.values.openInTapClient &&
      window.location.hostname === 'www.taptap.cn' &&
      window.moo.CONSTANT.IS_WECHAT &&
      window.moo.CONSTANT.IS_ANDROID
    ) {
      this.wxAppPath = window.moo.getUri(window.location.href);
      this.wxExtinfoStr = JSON.stringify({ path: this.wxAppPath });
    }
  },
  methods: {
    initEvent() {
      this.rocketOn('rocket:system:update-link', true, (v) => {
        this.link = v;
        if (this.localePath.length) {
          this.localePath = [];
          this.updateLocalePathMap();
        }
      });
    },
    getHrefByObject(link) {
      let href = '';
      let ua =
        window.moo?.ua?.text && window.moo?.ua?.text !== ''
          ? window.moo.ua.text
          : navigator.userAgent.toLocaleLowerCase();
      for (var i in link) {
        if (
          i !== 'ios' &&
          i !== 'android' &&
          i !== 'other' && // 1、优先正则匹配，所以 这些标准设备类型先排除，如果匹配不到，最后会用 link[this.device] 来识别,
          href === '' &&
          link[i] !== ''
        ) {
          // 2、正则匹配
          if (
            new RegExp(i).test(ua) ||
            new RegExp(i.toLowerCase()).test(ua) // 匹配小写 ua，比如 Macintosh， ua 里面是 macintosh 。
          ) {
            // 以第一个匹配到的为准
            // isHitRegExp = true;
            href = link[i];
            break;
          }
        }
      }
      if (href === '') {
        // 3、如果没有最终没有匹配到链接使用设备判断，再没有就用 other
        href = link[this.device] || ''; // || href.other || href.android
      }
      return href;
    },
    handleTapLink(e) {
      const { values } = this;
      if (this.values.openInTapClient && !window.moo.CONSTANT.IS_IN_TAPTAP) {
        //触发端外引流
        this.$bus.$emit(
          'rocket:remote:CustomTapGlobalDefaultComponent:openOrDownloadTapClient',
          ''
        );
      } else if (this.isInnerPage) {
        let t = values?.linkConfig?.open ? 'open' : 'jump';
        this.$bus.$emit(`rocket:system:${t}Page`, {
          key: this.href.substring(1),
        });
      } else if (this.isAnchorLink && this.values.linkConfig?.scroll) {
        let el = document.getElementById(this.href.substring(1));
        let frameEl = el.closest('.widget-frame-popup');
        let isDocument = false;
        if (frameEl) {
          // 目标锚点在内页里面时，如果被隐藏，不滚动
          if (frameEl.classList.contains('rocket-hide')) return;
        } else {
          frameEl = document.body;
          isDocument = true;
        }
        if (el) {
          let offsetTop = 0;
          do {
            offsetTop += el.offsetTop;
            // 子页面，不需要触发主页的滚动条
            if (el.classList.contains('widget-frame-popup')) {
            }
            el = el.offsetParent;
          } while (el !== frameEl);
          this.$nextTick(() => {
            try {
              if (isDocument) frameEl = window;
              frameEl.scrollTo({
                top: offsetTop,
                behavior: 'smooth',
              });
            } catch (error) {
              window?.scrollTo(0, offsetTop);
            }
          });
        }
      } else {
        const d = window.moo.CONSTANT;
        if (d.IS_IOS && (d.IS_WECHAT || d.IS_BROWSER_QQ)) {
          if (this.href.includes('apple.com') || this.href.includes('.apk')) {
            window.moo.$bus.$emit('rocket:ui:showToast', 'wxDownload', '', 20);
          }
        }
      }
      this.handleTap(e);
    },
    handleWxTagReady(e) {
      this.wxReady = true;
      var btn = e.target;
      btn.addEventListener('click', this.handleWxTagClick);
      btn.addEventListener('launch', this.handleWxTagLaunch);
    },
    handleWxTagClick() {
      if (!this.wxReady) return;
      this.handleTap();
    },
    handleWxTagLaunch() {
      this.$bus.$emit(
        'rocket:remote:CustomTapGlobalDefaultComponent:reportAppOpenFromWx',
        this.wxAppPath
      );
    },
    handleWxTagError() {
      if (!this.wxReady) return;
      this.$bus.$emit(
        'rocket:remote:CustomTapGlobalDefaultComponent:openOrDownloadTapClient',
        ''
      );
    },
    regularGet(href) {
      if (href !== undefined && href !== '') {
        // 匹配所有GET[]设置
        let GET_list = href.match(/GET(\[).*?(\])/g);
        if (GET_list && GET_list.length !== 0) {
          GET_list.forEach((g) => {
            let params = g.slice(4, g.indexOf(']')).split(',');

            let key = params[0];
            let _defaultVal = params[1] || '';
            let defaultVal = _defaultVal
              .replace(/^\s+|\s+$/gm, '')
              .replace(/(\'|\")/gm, '');
            let _prefix = params[2] || '';
            let prefix = _prefix
              .replace(/^\s+|\s+$/gm, '')
              .replace(/(\'|\")/gm, '');

            if (this.request[key]) {
              // 网址参数 - 已设置
              href = href.replace(g, prefix + this.request[key]);
            } else {
              // 网址参数 - 未设置
              // 这里如果 defaultVal 为空时，在服务端渲染时会输出一个将变量替换为空的网址，这个网址可能会时错误的，在 js 没有加载完成前会导致访问链接错误
              if (defaultVal === '') {
                if (process.server) {
                  href = '';
                } else {
                  console.warn(
                    href,
                    'The default value is empty, which may cause URL errors during initialization'
                  );
                }
              }
              href = href.replace(g, defaultVal);
            }
          });
        }
      }
      return href;
    },
  },
};
